<div fxLayout="row" fxLayoutAlign="start center">
    <div class="preview" [style.backgroundColor]="item.color"></div>
    <div>
        {{item.title}}
    </div>
</div>